var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useRef } from 'react';
import { Autocomplete } from './index';
export function StableAutocomplete(props) {
    var _a;
    var cacheRef = useRef(new Map());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var getOptionValue = (_a = props.getOptionValue) !== null && _a !== void 0 ? _a : (function (o) { var _a; return (o == null ? o : (_a = o.id) !== null && _a !== void 0 ? _a : o); });
    var stableOptions = useMemo(function () {
        var _a, _b, _c;
        var cache = cacheRef.current;
        var currentValues = new Set((_b = (_a = props.options) === null || _a === void 0 ? void 0 : _a.map(getOptionValue)) !== null && _b !== void 0 ? _b : []);
        cache.forEach(function (_, key) {
            if (!currentValues.has(key))
                cache.delete(key);
        });
        return ((_c = props.options) !== null && _c !== void 0 ? _c : []).map(function (o) {
            var key = getOptionValue(o);
            var cached = cache.get(key);
            if (cached != null)
                return cached;
            cache.set(key, o);
            return o;
        });
    }, [props.options, getOptionValue]);
    return _jsx(Autocomplete, __assign({}, props, { options: stableOptions }));
}
